import React from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { CalendarDaysIcon, MapPinIcon, UsersIcon, ClockIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

export default function RaceDay() {
    const { t } = useTranslation();
    const data = t("raceday", { returnObjects: true });
    return (
        <div className="text-white md:px-0 px-4">
            {/* <div className="relative">
                <PageTitle title={t("racedayTitle")} />
            </div> */}
            <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("racedayTitle")} />
            </div>
            <div className="top-12 md:top-40 lg:top-60 relative bg-white">
                <div className="bg-white min-h-screen container mx-auto w-full font-poppins text-[#164481] md:px-8 xl:px-0">
                    {/* <p className="text-sm md:text-base font-light">{t("prizeTitle")}</p> */}
                    {/* <p className="font-normal uppercase md:text-2xl pt-0">{data[0].title}</p>
                    <div className="w-full grid grid-cols-2 md:grid-cols-3">
                        <div className="space-y-4 inline-flex space-x-3 place-self-start md:place-self-center">
                            <CalendarDaysIcon width={24} />
                            <div>
                                <h1 className="text-xl font-bold capitalize">{data[1].title}</h1>
                                <p className="text-sm md:text-base font-light">{data[1].content}</p>
                            </div>
                        </div>

                        <div className="space-y-4 inline-flex space-x-3 place-self-start md:place-self-center">
                            <MapPinIcon width={24} />
                            <div>
                                <h1 className="text-xl font-bold capitalize">
                                    {data[2].title}
                                </h1>
                                <p className="text-sm md:text-base font-light">{data[2].content}</p>
                            </div>
                        </div>

                        <div className="space-y-4 inline-flex space-x-3 place-self-start md:place-self-center">
                            <ClockIcon width={24} />
                            <div>
                                <h1 className="text-xl font-bold capitalize">{data[3].title}</h1>
                                <p className="text-sm md:text-base font-light">{data[3].content}</p>
                            </div>
                        </div>
                    </div> */}
                    <p className="font-normal uppercase md:text-2xl mt-20">{data[4].title}</p>
                    <div className="w-full grid grid-cols-2 md:grid-cols-4">
                        <div className="space-y-4 inline-flex space-x-3 place-self-start md:place-self-center">
                            <CalendarDaysIcon width={24} />
                            <div>
                                <h1 className="text-xl font-bold capitalize">{data[5].title}</h1>
                                <p className="text-sm md:text-base font-light">{data[5].content}</p>
                            </div>
                        </div>

                        <div className="space-y-4 inline-flex space-x-3 place-self-start md:place-self-center">
                            <MapPinIcon width={24} />
                            <div>
                                <h1 className="text-xl font-bold capitalize">
                                    {data[6].title}
                                </h1>
                                <p className="text-sm md:text-base font-light">{data[6].content}</p>
                            </div>
                        </div>

                        <div className="space-y-4 inline-flex space-x-3 place-self-start md:place-self-center">
                            <MapPinIcon width={24} />
                            <div>
                                <h1 className="text-xl font-bold capitalize">
                                    {data[7].title}
                                </h1>
                                <p className="text-sm md:text-base font-light">{data[7].content}</p>
                            </div>
                        </div>

                        <div className="space-y-4 inline-flex space-x-3 place-self-start md:place-self-center">
                            {/* <UsersIcon width={24} /> */}
                            <ClockIcon width={24} />
                            <div>
                                <h1 className="text-xl font-bold capitalize">{data[8].title}</h1>
                                <p className="text-sm md:text-base font-light">{data[8].content}</p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-20 mb-24 h-screen hidden">
                        <iframe
                            title="Lokasi"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.7543729483937!2d107.60744187573943!3d-6.919940467731488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e63aab322609%3A0x1cf8cf0bc35d1e9d!2sBank%20BJB%20-%20Cabang%20Utama%20Bandung!5e0!3m2!1sen!2sid!4v1741281576929!5m2!1sen!2sid"
                            allowfullscreen="true"
                            loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"
                            className="invert w-full h-[40rem] rounded-lg"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
}
